import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { Navbar } from "@/components/Navbar";
import { Hero } from "@/components/Hero";
import { ValueProposition } from "@/components/ValueProposition";
import { Showcase } from "@/components/Showcase";
import { HowItWorks } from "@/components/HowItWorks";
import { Differentiation } from "@/components/Differentiation";
import { Testimonials } from "@/components/Testimonials";
import { CTABand } from "@/components/CTABand";
import { Footer } from "@/components/Footer";
import { HomeSEO } from "@/components/SEO";
import { PromoBanner } from "@/components/PromoBanner";
import { useAuth } from "@/hooks/useAuth";
import { useAdminRole } from "@/hooks/useAdminRole";
import { usePartnerRole } from "@/hooks/usePartnerRole";
import { Loader2 } from "lucide-react";

const Index = () => {
  const navigate = useNavigate();
  const { user, loading: authLoading } = useAuth();
  const { hasAccess: isAdmin, loading: roleLoading } = useAdminRole();
  const { isPartner, loading: partnerLoading } = usePartnerRole();

  useEffect(() => {
    // Redirect authenticated users to appropriate dashboard
    if (user && !authLoading && !roleLoading && !partnerLoading) {
      if (isAdmin) {
        navigate("/admin", { replace: true });
      } else if (isPartner) {
        navigate("/partner", { replace: true });
      } else {
        navigate("/dashboard", { replace: true });
      }
    }
  }, [user, authLoading, roleLoading, partnerLoading, isAdmin, isPartner, navigate]);

  // Show loading while checking auth status
  if (authLoading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-background">
        <Loader2 className="w-8 h-8 animate-spin text-accent" />
      </div>
    );
  }

  // If user is authenticated, don't render homepage (redirect will happen)
  if (user) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-background">
        <Loader2 className="w-8 h-8 animate-spin text-accent" />
      </div>
    );
  }

  return (
    <div className="min-h-screen">
      <PromoBanner />
      <HomeSEO />
      <Navbar />
      <Hero />
      <ValueProposition />
      <Showcase />
      <HowItWorks />
      <Differentiation />
      <Testimonials />
      <CTABand />
      <Footer />
    </div>
  );
};

export default Index;
